import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
// tslint:disable-next-line:no-var-requires
const opportunityicon = require('../../resources/USD.png');
import * as moment from 'moment';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as shortId from 'shortid';
import Modal from '../../components/modal/modal';
import {
    Comment,
    OpportunitiesClient,
    OpportunityHeadRate,
    OpportunityHeadStatusCode,
    Rate,
    StatusCode
} from '../../data/apiClient/client';
import { opportunitiesActionCreators } from '../../data/opportuneties/opportunetisActions';
import { ApiOpportunitiesState } from '../../data/opportuneties/opportunetisModels';

// import opportunities from '../Opportunities/opportunities';
// import * as FontAwesome from 'react-fontawesome';
// import * as Client from '../../data/apiClient/client';

type OpportunitieProps = OpportunitieState & // ... state we've requested from the Redux store
    OpportunitieActions & // ... plus action creators we've requested
    RouteComponentProps<{ id: string }>;

interface OpportunitieState {
    header: HeaderState;
    opportunities: ApiOpportunitiesState;
}

interface OpportunitieActions {
    headerActions: typeof headerActionCreators;
    opportunitiesActions: typeof opportunitiesActionCreators;
}

interface State {
    name?: string;
    company?: string;
    city?: string;
    state?: string;
    email?: string;
    phonenumber?: string;
    date?: string;
    Topic?: string;
    industry?: string;
    description?: string;
    rating?: OpportunityHeadRate;
    id?: string;
    displayError: boolean;
    comments: Comment[] | undefined;
    commentValue?: string;
    commentSavingError: boolean;
    savingComment: boolean;
    statusCode?: OpportunityHeadStatusCode;
    confirmationModalId: string;
    selectedOpportunetyStatus?: boolean;
}

class Opportunitie extends React.PureComponent<OpportunitieProps, State> {
    OC: OpportunitiesClient = new OpportunitiesClient();
    constructor(props: OpportunitieProps) {
        super(props);
        this.state = {
            name: undefined,
            company: undefined,
            city: undefined,
            state: undefined,
            email: undefined,
            phonenumber: undefined,
            date: undefined,
            Topic: undefined,
            industry: undefined,
            description: undefined,
            rating: undefined,
            id: undefined,
            displayError: false,
            comments: undefined,
            commentValue: undefined,
            commentSavingError: false,
            savingComment: false,
            statusCode: undefined,
            confirmationModalId: 'CONFIRMATIONMODAL2',
            selectedOpportunetyStatus: undefined
        };
        this.getTheOpportunitie = this.getTheOpportunitie.bind(this);
        this.setRating = this.setRating.bind(this);
        this.getRatingString = this.getRatingString.bind(this);
        this.convertOpportunityHeadRateToRate = this.convertOpportunityHeadRateToRate.bind(this);
        this.fetchOpportunities = this.fetchOpportunities.bind(this);
        this.saveComment = this.saveComment.bind(this);
        this.getComments = this.getComments.bind(this);
        this.renderLoading = this.renderLoading.bind(this);
        this.formatInformation = this.formatInformation.bind(this);
        this.returnStatus = this.returnStatus.bind(this);
        this.onCloseOpportunity = this.onCloseOpportunity.bind(this);
    }

    componentWillMount() {
        this.getTheOpportunitie(this.props.match.params.id);
    }

    returnStatus(statusCode: OpportunityHeadStatusCode, opportunityid?: string) {
        switch (statusCode) {
            case 'open':
                return (
                    <div>
                        <button
                            className="btn btn-outline-success mr-2"
                            data-toggle="modal"
                            data-target={'#' + this.state.confirmationModalId}
                            onClick={(event) => {
                                this.setState({
                                    selectedOpportunetyStatus: true
                                });
                                event.stopPropagation();
                                event.preventDefault();
                            }}
                        >
                            Mark as won
                        </button>
                        <button
                            className="btn btn-outline-danger"
                            data-toggle="modal"
                            data-target={'#' + this.state.confirmationModalId}
                            onClick={(event) => {
                                this.setState({
                                    selectedOpportunetyStatus: false
                                });
                                event.stopPropagation();
                                event.preventDefault();
                            }}
                        >
                            Mark as lost
                        </button>
                    </div>
                );
            case 'won':
                return (
                    <div>
                        <span className="badge badge-success">Won</span>
                    </div>
                );
            case 'lost':
                return (
                    <div>
                        <span className="badge badge-danger">Lost</span>
                    </div>
                );
            default:
                return <React.Fragment />;
        }
    }

    onCloseOpportunity() {
        if (this.state.id && this.state.selectedOpportunetyStatus !== undefined) {
            this.OC.setStatus(this.state.id, this.state.selectedOpportunetyStatus ? StatusCode.Won : StatusCode.Lost)
                .then(() => {
                    this.props.opportunitiesActions.GetOpportunities();
                })
                .catch((err) => {
                    // console.log(err);
                });
        }
    }

    renderLoading() {
        return (
            <div>
                <FontAwesome className="progressicon" name="spinner" size="2x" spin={true} />
            </div>
        );
    }

    formatInformation(info: string) {
        return info.split('\n').map((row: string) => {
            return <div key={shortId.generate()}>{row}</div>;
        });
    }

    saveComment() {
        if (this.state.id) {
            this.setState({ savingComment: true });
            const newComment: Comment = new Comment();
            newComment.commentDate = new Date();
            newComment.opportunityId = this.state.id;
            newComment.information = this.state.commentValue;
            this.OC.addComment(newComment)
                .then(() => {
                    if (this.state.id) {
                        this.getComments(this.state.id);
                    }
                })
                .catch((error) => {
                    this.setState({ commentSavingError: true, savingComment: false });
                });
        } else {
            this.setState({ commentSavingError: true, savingComment: false });
        }
    }

    componentDidUpdate(prevProps: OpportunitieProps, prevState: State) {
        if (prevProps.opportunities.opportunities !== this.props.opportunities.opportunities) {
            this.getTheOpportunitie(this.props.match.params.id);
        }
    }

    getComments(opportunityId: string) {
        if (opportunityId) {
            this.OC.getcomments(opportunityId).then((response: Comment[]) => {
                this.setState({
                    comments: response,
                    savingComment: false,
                    commentSavingError: false,
                    commentValue: undefined
                });
            });
        }
    }

    fetchOpportunities() {
        this.props.opportunitiesActions.GetOpportunities();
    }

    convertOpportunityHeadRateToRate(rate: OpportunityHeadRate) {
        switch (rate) {
            case OpportunityHeadRate.Warm:
                return Rate.Warm;
            case OpportunityHeadRate.Hot:
                return Rate.Hot;
            case OpportunityHeadRate.Cold:
                return Rate.Cold;
            case OpportunityHeadRate.Notdefined:
            default:
                return Rate.Notdefined;
        }
    }

    getRatingString(rating?: OpportunityHeadRate) {
        switch (rating) {
            case OpportunityHeadRate.Warm:
                return 'Warm';
            case OpportunityHeadRate.Hot:
                return 'Hot';
            case OpportunityHeadRate.Cold:
                return 'Cold';
            case OpportunityHeadRate.Notdefined:
            default:
                return 'Not defined';
        }
    }

    setRating(rating: OpportunityHeadRate) {
        if (this.state.id) {
            this.OC.setRating(this.state.id, this.convertOpportunityHeadRateToRate(rating))
                .then(() => {
                    this.fetchOpportunities();
                    this.setState({ displayError: false });
                })
                .catch(() => {
                    this.setState({ displayError: true });
                });
            this.setState({ rating: rating });
        }
    }

    getTheOpportunitie(index: string) {
        // let opportunity = this.props.opportunities.opportunities.find((this.props.opportunities.opportunities) => {
        this.props.opportunities.opportunities.map((opportunity) => {
            if (opportunity.opportunityid === index) {
                this.getComments(opportunity.opportunityid);
                this.setState({
                    commentSavingError: false,
                    name: opportunity.name,
                    company: opportunity.company,
                    city: opportunity.city,
                    state: opportunity.state,
                    email: opportunity.email,
                    phonenumber: opportunity.phonenumber,
                    date: moment(opportunity.createdDate, 'M/D/YYYY').format('M/D/YYYY'),
                    Topic: opportunity.topic,
                    industry: opportunity.industry,
                    description: opportunity.descripton,
                    id: opportunity.opportunityid,
                    rating: opportunity.rate,
                    statusCode: opportunity.statusCode
                });
            }
        });
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Opportunity'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={opportunityicon} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.opportunities.loading ? (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Name:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.name ? this.state.name : ''}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Company:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.company ? this.state.company : ''}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">City:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.city ? this.state.city : ''}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">State:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.state ? this.state.state : ''}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Phone:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.phonenumber ? this.state.phonenumber : ''}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Email:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.email ? this.state.email : ''}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Date:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.date ? this.state.date : ''}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Topic:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.Topic ? this.state.Topic : ''}</div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Industry:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>{this.state.industry ? this.state.industry : ''}</div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Description:</div>
                                                </div>
                                                <div className="col-sm-9">
                                                    <div>{this.state.description ? this.state.description : ''}</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Rate this opportunity:</div>
                                                    {this.state.displayError ? (
                                                        <div className="bold">
                                                            An error occurred while saving, new rating not saved.
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                                <div className="col-sm-3">
                                                    {this.state.id ? (
                                                        <div className="dropdown">
                                                            <div
                                                                className="btn-link dropdown-toggle"
                                                                id="dropdownMenuButton"
                                                                data-toggle="dropdown"
                                                                aria-haspopup="true"
                                                                aria-expanded="false"
                                                            >
                                                                {this.getRatingString(this.state.rating)}
                                                            </div>
                                                            <div
                                                                className="dropdown-menu"
                                                                aria-labelledby="dropdownMenuButton"
                                                            >
                                                                {/* <a
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                            this.setRating(OpportunityHeadRate.Notdefined);
                                                        }}
                                                    >
                                                        Not defined
                                                    </a> */}
                                                                <a
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        this.setRating(OpportunityHeadRate.Hot);
                                                                    }}
                                                                >
                                                                    Hot
                                                                </a>
                                                                <a
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        this.setRating(OpportunityHeadRate.Warm);
                                                                    }}
                                                                >
                                                                    Warm
                                                                </a>
                                                                <a
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        this.setRating(OpportunityHeadRate.Cold);
                                                                    }}
                                                                >
                                                                    Cold
                                                                </a>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="bold">Status:</div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div>
                                                        {this.state.statusCode && this.state.id ? (
                                                            this.returnStatus(this.state.statusCode, this.state.id)
                                                        ) : (
                                                            <React.Fragment />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {this.state.id ? (
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="commentsSection">
                                            <h5 className="commentsSectionHeader">Comments</h5>
                                            <div>
                                                {!this.state.savingComment ? (
                                                    <div>
                                                        <textarea
                                                            rows={4}
                                                            cols={50}
                                                            value={this.state.commentValue}
                                                            onChange={(
                                                                event: React.ChangeEvent<HTMLTextAreaElement>
                                                            ) => {
                                                                this.setState({
                                                                    commentValue: event.currentTarget.value
                                                                });
                                                            }}
                                                        />
                                                        <div>
                                                            {this.state.commentSavingError ? (
                                                                <div className="bold">
                                                                    An error occurred while saving, new comment not
                                                                    saved.
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            <button
                                                                onClick={() => {
                                                                    this.saveComment();
                                                                }}
                                                                className="btn btn-primary"
                                                            >
                                                                Save comment
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>{this.renderLoading()}</div>
                                                )}
                                            </div>

                                            {this.state.comments && this.state.comments.length > 0 ? (
                                                this.state.comments
                                                    .map((comment: Comment) => {
                                                        return (
                                                            <div key={shortId.generate()}>
                                                                <div className="dropdown-divider" />
                                                                <div>
                                                                    {moment(comment.commentDate).format('YYYY-MM-DD') +
                                                                        ':'}
                                                                </div>
                                                                <div>
                                                                    {comment.information &&
                                                                    comment.information!.indexOf('\n')
                                                                        ? this.formatInformation(comment.information)
                                                                        : comment.information}
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                    .reverse()
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                            <Modal
                                id={this.state.confirmationModalId}
                                modalBody={<h4>Are you sure you want to close this opportunity?</h4>}
                                modalFooter={
                                    <React.Fragment>
                                        <button
                                            data-dismiss="modal"
                                            className="btn btn-success"
                                            onClick={this.onCloseOpportunity}
                                        >
                                            {this.state.selectedOpportunetyStatus ? 'Close as won' : 'Close as lost'}
                                        </button>
                                        <button className="btn btn-error" data-dismiss="modal">
                                            {'Cancel'}
                                        </button>
                                    </React.Fragment>
                                }
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): OpportunitieState {
    return {
        header: state.header,
        opportunities: state.opportunities
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): OpportunitieActions {
    return {
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        opportunitiesActions: bindActionCreators(opportunitiesActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Opportunitie)
);



// WEBPACK FOOTER //
// ./src/containers/opportunitie/opportunitie.tsx